import { waitForTarget } from '@rambler-id/promise';
import { createDebug } from '@rambler-id/debug';
const debug = createDebug('common:metrics:ya');
const DEFAULT_YANDEX_METRICA_PARAMS = {
    clickmap: true,
    trackLinks: true,
    triggerEvent: true,
    accurateTrackBounce: true,
    trackHash: true,
    webvisor: true
};
export const activateYandexMetrika = (option) => {
    return new Promise((resolve) => {
        if (process.env.NODE_ENV === 'development') {
            resolve();
            return;
        }
        /* eslint-disable */
        // prettier-ignore
        (function (m, e, t, r, i, k, a) {
            // @ts-ignore
            m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments); };
            // @ts-ignore
            m[i].l = 1 * new Date();
            k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, k.onload = () => resolve(), k.onerror = () => resolve(), a.parentNode.insertBefore(k, a);
        })(window, document, 'script', '//mc.yandex.ru/metrika/tag.js', 'ym');
        try {
            const options = Array.isArray(option) ? option : [option];
            options.forEach(({ counterKey, params }) => {
                // @ts-ignore
                ym(counterKey, 'init', {
                    ...DEFAULT_YANDEX_METRICA_PARAMS,
                    ...params
                });
            });
        }
        catch (e) { }
        /* eslint-enable */
    });
};
export const createYandexMetrikaHit = (counterKey) => async (params) => {
    if (process.env.NODE_ENV === 'development') {
        debug(`yandexMetrikaHit ${counterKey} %o`, params);
        return;
    }
    try {
        const yaCounter = await waitForTarget(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        () => window.ym, 1000);
        yaCounter(counterKey, 'hit', params);
    }
    catch { }
};
export const createYandexMetrikaSetParams = (counterKey) => async (params) => {
    if (process.env.NODE_ENV === 'development') {
        debug(`yandexMetrikaSetParams ${counterKey} %o`, params);
        return;
    }
    try {
        const yaCounter = await waitForTarget(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        () => window.ym, 1000);
        yaCounter(counterKey, 'params', params);
    }
    catch { }
};
export const createYandexMetrikaReachGoal = (counterKey) => async (...args) => {
    if (process.env.NODE_ENV === 'development') {
        debug(`yandexMetrikaReachGoal ${counterKey} %o`, args);
        return;
    }
    try {
        const yaCounter = await waitForTarget(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        () => window.ym, 1000);
        yaCounter(counterKey, 'reachGoal', ...args);
    }
    catch { }
};
